import { CSSProperties } from 'react'
import { StyleSkeleton } from './style'
interface SkeletonProps {
  style?: CSSProperties
  width?: number | string
  height?: number | string
  radius?: number | string
}
const Skeleton = (props: SkeletonProps) => {
  return <StyleSkeleton {...props} />
}

export default Skeleton
